module.exports = __webpack_public_path__ + "static/media/ObservationPhysical.9ad2e5f9.jpg";